import { licenceConstants } from "../_constants";

const initialState = {
    data: [],
    loading: false
}

export function licence(state = initialState, action) {
    switch (action.type) {
        case licenceConstants.LICENCE_LOADING:
            return {
                ...state,
                loading: true,
                data: []
            };
        case licenceConstants.LICENCE_LOADED:
            return {
                ...state,
                loading: false,
                data: action.data
            };
        case licenceConstants.LICENCE_ERROR:
            return {
                ...state,
                loading:false,
                data: []
            };
        default:
            return state;
    }
}